import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {SetAccessibilityType} from "./__graphql-types__/index.ts";

export const SET_ACCESSIBILITY_SETTINGS_MUTATION: GqlOperation<
    SetAccessibilityType["response"],
    SetAccessibilityType["variables"]
> = gqlOp(gql`
    mutation SetAccessibility(
        $kaid: String!
        $hideVisual: Boolean!
        $prefersReducedMotion: Boolean!
        $noColorInVideos: Boolean!
        $soundOn: Boolean
    ) {
        setSettings(
            kaid: $kaid
            hideVisual: $hideVisual
            prefersReducedMotion: $prefersReducedMotion
            noColorInVideos: $noColorInVideos
            soundOn: $soundOn
        ) {
            user {
                id
                hideVisual
                prefersReducedMotion
                noColorInVideos
                soundOn
            }
            errors {
                code
            }
        }
    }
`);

export default SET_ACCESSIBILITY_SETTINGS_MUTATION;
